<script>
  /* Заглушка раздела, который временно закрыт. Сам раздел и его данные
     остаются в коде — меняется только то, что видит игрок.
     Сейчас так закрыт «Магазин» (см. архив вкладок в mainmenu.svelte). */
  import Ico from '../ico.svelte';

  export let title = 'Раздел на доработке';
  export let text = 'Категория временно закрыта — скоро вернём.';
</script>

<div class="soon">
  <div class="soon__ic"><Ico n="settings" s={34} /></div>
  <div class="soon__t">{title}</div>
  <div class="soon__s">{text}</div>
  <div class="soon__bar"><span></span></div>
</div>

<style>
  .soon {
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    gap: 14px; width: 100%; height: 100%; text-align: center;
  }
  .soon__ic {
    display: grid; place-items: center; width: 84px; height: 84px; border-radius: 26px;
    color: var(--gold, #e7ae3f);
    background: radial-gradient(70% 70% at 50% 30%, rgba(231, 174, 63, .16), rgba(231, 174, 63, .04));
    border: 1px solid rgba(231, 174, 63, .28);
  }
  .soon__t { font-size: 22px; font-weight: 700; color: #edeff4; letter-spacing: .01em; }
  .soon__s { max-width: 420px; font-size: 14px; line-height: 1.55; color: rgba(237, 239, 244, .45); }
  .soon__bar { width: 220px; height: 3px; border-radius: 3px; overflow: hidden; background: rgba(255, 255, 255, .08); }
  .soon__bar span {
    display: block; width: 40%; height: 100%; border-radius: 3px;
    background: linear-gradient(90deg, transparent, var(--gold, #e7ae3f), transparent);
    animation: soonrun 1.8s ease-in-out infinite;
  }
  @keyframes soonrun { 0% { transform: translateX(-110%); } 100% { transform: translateX(260%); } }
  @media (prefers-reduced-motion: reduce) { .soon__bar span { animation: none; } }
</style>
